<template>
  <div>
    <!-- Field Type Text -->
    <div class="field" v-if="field.type === 'text'">
      <div class="field-text">
        <md-field v-if="field.answerLength === 'short'">
          <label>{{ field.question }}</label>
          <md-input :disabled="!preview"></md-input>
        </md-field>
        <md-field v-else-if="field.answerLength === 'long'">
          <label>{{ field.question }}</label>
          <md-textarea :disabled="!preview"></md-textarea>
        </md-field>
      </div>
    </div>

    <!-- Choice -->
    <div class="field" v-if="field.type === 'choice'">
      <div class="field-choice">
        <div>
          <label>{{ field.question }}</label>
        </div>
        <md-checkbox
          v-for="option in field.options"
          :key="option.id"
          v-model="option.value"
          :disabled="!preview"
          >{{ option.label }}</md-checkbox
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormField",
  props: ["field", "preview"],
};
</script>

<style lang="scss" scoped>
.md-checkbox {
  display: flex;
}
</style>